var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 0C4.02869 0 0 4.02869 0 9C0 13.9713 4.02869 18 9 18C13.9713 18 18 13.9713 18 9C18 4.02869 13.9713 0 9 0ZM9 17.143C4.5 17.143 0.85702 13.5001 0.85702 9C0.85702 4.49993 4.49993 0.85702 9 0.85702C13.5001 0.85702 17.143 4.49993 17.143 9C17.143 13.5001 13.5001 17.143 9 17.143Z",
    fill: "#D80000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 17.143C4.5 17.143 0.85702 13.5001 0.85702 9C0.85702 4.49993 4.49993 0.85702 9 0.85702C13.5001 0.85702 17.143 4.49993 17.143 9C17.143 13.5001 13.5001 17.143 9 17.143Z",
    fill: "#D80000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99997 10.7144C9.23573 10.7144 9.42859 10.5215 9.42859 10.2858V5.35709C9.42859 5.12132 9.23573 4.92847 8.99997 4.92847C8.76421 4.92847 8.57135 5.12132 8.57135 5.35709V10.2858C8.57135 10.5215 8.76421 10.7144 8.99997 10.7144Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.64283 12.4285C9.64283 12.7837 9.35498 13.0714 8.99997 13.0714C8.64497 13.0714 8.35712 12.7837 8.35712 12.4285C8.35712 12.0735 8.64497 11.7856 8.99997 11.7856C9.35498 11.7856 9.64283 12.0735 9.64283 12.4285Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorFill);
export default __webpack_public_path__ + "static/media/error-fill.240870596bb1f9b3b8a9cbebdce8d4c6.svg";
export { ForwardRef as ReactComponent };